export const GET_CITY_WEATHER = 'GET_CITY_WEATHER';
export const RESET = "RESET";
export const GET_GEO_CITY_WEATHER = "GET_GEO_CITY_WEATHER";